import React from 'react';

// mui icons
import Apps from '@mui/icons-material/Apps';
import AttachMoney from '@mui/icons-material/AttachMoney';


import BadgeOutlineIcon from 'mdi-react/BadgeAccountHorizontalOutlineIcon';
import BunkBedIcon from 'mdi-react/BunkBedIcon';
import CallMade from '@mui/icons-material/CallMade';
//import CalendarIcon from '@mui/icons-material/CalendarToday';
import Cloud from '@mui/icons-material/Cloud';
import CreditCard from '@mui/icons-material/CreditCard';
import Document from '@mui/icons-material/Description';
import Email from '@mui/icons-material/Email';
import Face from '@mui/icons-material/Face';
import FileCompareIcon from 'mdi-react/FileCompareIcon';
import FormatAlignLeft from '@mui/icons-material/FormatAlignLeft';
import FormatListBulleted from '@mui/icons-material/FormatListBulleted';
import Group from '@mui/icons-material/Group';
import HandymanOutlinedIcon from '@mui/icons-material/HandymanOutlined';
import History from '@mui/icons-material/History';
import Hotel from '@mui/icons-material/Hotel';
import Image from '@mui/icons-material/Wallpaper';
import InfoIcon from '@mui/icons-material/Info';
import KingBed from '@mui/icons-material/KingBed';
import Language from '@mui/icons-material/Language';
import LineStyle from '@mui/icons-material/LineStyle';
import ListAlt from '@mui/icons-material/ListAlt';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import MessagesIcon from '@mui/icons-material/Announcement';
import Person from '@mui/icons-material/Person';
import Place from '@mui/icons-material/Place';
import QueryStatsOutlinedIcon from '@mui/icons-material/QueryStatsOutlined';
import RecordVoiceOver from '@mui/icons-material/RecordVoiceOver';
import RoomServiceIcon from 'mdi-react/RoomServiceIcon';
import SaleIcon from 'mdi-react/SaleIcon';
import Send from '@mui/icons-material/Send';
import SettingsIcon from '@mui/icons-material/Settings';
import SettingsSuggestOutlinedIcon from '@mui/icons-material/SettingsSuggestOutlined';
import SmartButtonIcon from '@mui/icons-material/SmartButton';
import SmartDisplayIcon from '@mui/icons-material/SmartDisplay';
//import ShoppingCart from '@mui/icons-material/ShoppingCart';
import Timeline from '@mui/icons-material/Timeline';
import Translate from '@mui/icons-material/Translate';
import ViewHeadline from '@mui/icons-material/ViewHeadline';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import WarningIcon from '@mui/icons-material/Warning';

// mdi icons
import Acquirer from 'mdi-react/AccountCreditCardIcon'
import CalendarStarIcon from 'mdi-react/CalendarStarIcon';
import FormatListChecksIcon from 'mdi-react/FormatListChecksIcon';
import HumanMaleBoyIcon from 'mdi-react/HumanMaleBoyIcon';
import LockIcon from 'mdi-react/LockIcon';
import RayStartArrow from 'mdi-react/RayStartArrowIcon'
import ResponsiveIcon from 'mdi-react/ResponsiveIcon'
import TableIcon from 'mdi-react/TableIcon';
import TextSubjectIcon from 'mdi-react/TextSubjectIcon';
import WrenchIcon from 'mdi-react/WrenchIcon'


// https://material.io/tools/icons/?style=baseline
// https://mui.com/material-ui/material-icons/
// https://materialdesignicons.com

const Menuicons = {

  contact: <MailOutlineIcon />,
  infoarchiv: <InfoIcon />,
  ereignisarchiv: <WarningIcon />,
  video: <SmartDisplayIcon />,

  calYield: <Timeline />,
  calPricegr: <AttachMoney />,
  calOnline: <Language />,
  calService: <FormatListChecksIcon />,

  repBookingcom: <FileCompareIcon />,
    repBookingsheet: <FormatAlignLeft />,
  repHistory: <History />,
    repStats: <QueryStatsOutlinedIcon />,
    repDocuments: <Document />,
    repMessages: <MessagesIcon />,
  guests: <Face />,
  leer30: <Face />,
    repGuestexport: <CallMade />,
    repGuesthistory: <History />,
    repGdpr: <VisibilityOff />,
  auto: <Send />,
  leer40: <SettingsSuggestOutlinedIcon />,
    repAutomail: <Email />,
    repAutorep: <ListAlt />,
    repBfs: <Send />,
    auto_joy: <Send />,

  bwh: <ResponsiveIcon />,
    bwhSettings: <SettingsIcon />,
    bwhText: <TextSubjectIcon />,
    bwhImage: <Image />,
    bwhRoomcategory: <BunkBedIcon />,
    bwhService: <RoomServiceIcon />,
    bwhAgent: <RecordVoiceOver />,
    bwhGuestfield: <BadgeOutlineIcon />,
    bwhDiscount: <SaleIcon />,
    bwhTranslation: <Translate />,
  ota: <Cloud />,
    ota_booking: <Cloud />,
    ota_hostelworld: <Cloud />,
  dorm: <Language />,
    dorm_settings: <SettingsIcon />,
    dorm_blocks: <ViewHeadline />,
    dorm_online_text: <Language />,
    dorm_email_text: <Email />,
    dorm_zimmer_kat: <BunkBedIcon />,
    dorm_zusatzleistungen: <RoomServiceIcon />,
    
  sec_s_sheets: <FormatAlignLeft />,
    setBookingsheet: <FormatAlignLeft />,
    setImage: <Image />,
    setRoomcattext: <BunkBedIcon />,
    setServicetext: <RoomServiceIcon />,
  setService: <RoomServiceIcon />,
  setRoom: <Hotel />,
    setBed: <KingBed />,
    setRoomcategory: <BunkBedIcon />,
  setAgentcontract: <RecordVoiceOver />,
    setAgent: <RecordVoiceOver />,
  s_tag: <TableIcon />,
    setSpecialday: <CalendarStarIcon />,
    setAgecategory: <HumanMaleBoyIcon />,
    setPrefcountry: <Place />,
    setPaymenttype: <CreditCard />,
    setGuestcategory: <Group />,
    setGuestdetail: <FormatListBulleted />,
  s_dormbook: <Apps />,
  setAppopt: <Apps />,
    leer121: <Person />,
    setPwdyubi: <LockIcon />,
    sec_s_usergroup: <Group />,
    setDbuser: <Person />,
  setPayment: <CreditCard />,
    setPaymentapp: <CreditCard />,
    setAcquirer: <Acquirer />,
  s_maint: <WrenchIcon />,
  leer140: <WrenchIcon />,
    setTransfer: <RayStartArrow />,
    sec_s_maint_guest: <Face />,
    sec_s_maint_res: <LineStyle />,
  leer150: <HandymanOutlinedIcon />,
    setPricecomp: <ListAlt />,
    setTkonfigspez: <SmartButtonIcon />,
    setTkonfig: <HandymanOutlinedIcon />,

  globFindres: <Send />,
  globHostel: <Send />,
  sec_hostel: <Send />,
    sec_glob_map: <Send />,
    sec_glob_access: <Send />,
    glob_versions: <Send />,
  glob_users: <Send />,
    setDbuserglob: <Send />,
  sec_glob_payments: <Send />,
  glob_tables: <Send />,
    sec_glob_agent: <RecordVoiceOver />,
    sec_glob_country: <Send />,
    sec_glob_report: <Send />,
    sec_glob_error: <Send />,
    globPortalinfo: <Send />,
    sec_glob_logsched: <Send />,
  sec_glob_server: <Send />,
  globServer: <Send />,


}
export default Menuicons;
